/*
 * PM Farb-Schieber.
 *
 * Die gesamte Darstellung haengt an der CSS-Variablen --pm-split; das
 * Skript tut nichts weiter, als sie beim Ziehen nachzufuehren. Der
 * sichtbare Ausgangszustand kommt aus Liquid, die Seite steht also auch
 * dann richtig da, wenn das Modul gar nicht laedt - dann laesst sich
 * nur nichts verschieben.
 *
 * Bedient wird ein echtes <input type="range">, das unsichtbar ueber
 * der Flaeche liegt. Damit gibt es Ziehen, Tastatur und Screenreader
 * geschenkt, statt sie mit Zeigerereignissen nachzubauen.
 */

class PmColorSplit extends HTMLElement {
  #range = null;

  connectedCallback() {
    this.#range = this.querySelector('.pm-split__range');
    if (!this.#range) return;

    this.#range.addEventListener('input', this.#onInput);
    // Falls der Browser den Wert aus einer vorherigen Sitzung
    // wiederherstellt, stimmt er sonst nicht zur Kante.
    this.#onInput();
  }

  disconnectedCallback() {
    this.#range?.removeEventListener('input', this.#onInput);
    this.#range = null;
  }

  #onInput = () => {
    const wert = Number(this.#range.value);
    if (Number.isNaN(wert)) return;
    this.style.setProperty('--pm-split', String(wert));
  };
}

if (!customElements.get('pm-color-split')) {
  customElements.define('pm-color-split', PmColorSplit);
}
